import "../../stylesheets/about-package/about.less";
import "../../stylesheets/shared-package/shared.less";

import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import Link from "@khanacademy/wonder-blocks-link";

import {isNarrowMobile} from "#donate-package/styles.ts";

type Props = {
    videos: Array<any>;
};

export default class ColumnMajorOrderVideosList extends React.Component<Props> {
    render(): React.ReactNode {
        const {videos} = this.props;

        return (
            <div className="domain-table-container">
                <div className={css(styles.gridContainer)}>
                    {videos.map((video, index) => (
                        <div
                            key={video.id + index}
                            className={css(styles.subjectCell)}
                        >
                            <Link
                                className={css(styles.subjectLink)}
                                href={`/video?v=${video.youtubeId}`}
                                aria-label={video.description}
                            >
                                {video.title}
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}

const styles = StyleSheet.create({
    gridContainer: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr",
        [isNarrowMobile]: {
            gridTemplateColumns: "1fr",
        },
    },
    subjectCell: {
        border: "1px solid #ddd",
    },
    subjectLink: {
        background: "#fdfdfd",
        boxSizing: "border-box",
        display: "block",
        fontFamily: "inherit",
        padding: "5px 10px",
        textDecoration: "none",
    },
});
